<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Elementos: TPSNS, medicamentos e insumos</h4>
    <hr />

    <DataTable
      :data="elementos"
      :columns="[
        { label: 'Código',        field: 'codigo' },
        { label: 'Nombre',        field: 'nombre' },
        { label: 'Clasificación', field: 'clasElemNombre' },
      ]"
      idField="idElemento"
      mensajeVacio="No hay registros de elementos."
      :mostrarBotonNuevo="esAdmin"
      :mostrarEditar="esAdmin"
      :mostrarVer="esAdmin"
      :mostrarEliminar="esAdmin"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idElemento)"
      @view="row => abrirEditar(row.idElemento)"
    >
      <!-- Filtros extra en la barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto">
          <select
            class="form-select form-select-sm"
            style="width:200px"
            v-model="tipoBusqueda"
            @change="getDataTipo"
          >
            <option value="">-- Tipo --</option>
            <option
              v-for="tipoElem in tipoElems"
              :value="tipoElem.idTipoElem"
              :key="tipoElem.idTipoElem"
            >
              {{ tipoElem.nombre }}
            </option>
          </select>
        </div>
        <div class="col-auto">
          <select
            class="form-select form-select-sm"
            style="width:200px"
            v-model="clasificacionBusqueda"
            @change="getDataClasificacion"
          >
            <option value="">-- Clasificación --</option>
            <option
              v-for="clasElem in clasElems"
              :value="clasElem.idClasElem"
              :key="clasElem.idClasElem"
            >
              {{ clasElem.nombre }}
            </option>
          </select>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoElemento.idElemento" disabled />
                </div>
              </div>
            </div>
            <!-- Clasificación -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Clas Elem</label></div>
                <div class="col-10">
                  <select class="form-select" v-model="datoElemento.idClasElem">
                    <option disabled value="">Seleccione...</option>
                    <option
                      v-for="clasElem in clasElems"
                      :value="clasElem.idClasElem"
                      :key="clasElem.idClasElem"
                    >
                      {{ clasElem.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Código -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Código</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoElemento.codigo"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
            <!-- Nombre -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    v-model="datoElemento.nombre"
                    style="text-transform:uppercase"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarElemento"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarElemento"
              v-if=" btnEditar && esAdmin "
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      elementos:             [],
      datoElemento:          {},
      tipoBusqueda:          "",
      clasificacionBusqueda: "",
      titulo:                "",
      btnCrear:              false,
      btnEditar:             false,
      modalWindow:           true,
      tipoElems:             [],
      clasElems:             [],
      idPerfil:              0,
    };
  },
  computed: {
    esAdmin() {
      const idPerfil = Number(window.sessionStorage.getItem("idPerfil"));
      return idPerfil === 1;
    }
  },
  mounted() {
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchTipoElems();
    this.fetchClasElems();
  },
  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.tipoBusqueda          = "";
      this.clasificacionBusqueda = "";
      api.get("/vwelementos")
        .then(r => { this.elementos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar elementos:", e));
    },
    getDataTipo() {
      if (!this.tipoBusqueda) { this.getData(); return; }
      api.get("/vwelementos/idtipoelem/" + this.tipoBusqueda)
        .then(r => { this.elementos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al filtrar por tipo:", e));
    },
    getDataClasificacion() {
      if (!this.clasificacionBusqueda) { this.getData(); return; }
      api.get("/vwelementos/idclaselem/" + this.clasificacionBusqueda)
        .then(r => { this.elementos = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al filtrar por clasificación:", e));
    },
    // ── Fetch auxiliares ──────────────────────────────────────
    async fetchTipoElems() {
      try {
        const r      = await api.get("/vwtipoelems");
        this.tipoElems = r.data;
      } catch (e) {
        console.error("Error fetching tipoElems:", e.response?.data || e.message);
      }
    },
    async fetchClasElems() {
      try {
        const r      = await api.get("/vwclaselems");
        this.clasElems = r.data;
      } catch (e) {
        console.error("Error fetching clasElems:", e.response?.data || e.message);
      }
    },
    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoElemento,
        ["idClasElem", "nombre", "codigo"],
        ["idClasElem", "nombre", "codigo"]
      );
    },
    // ── CRUD ──────────────────────────────────────────────────
    async guardarElemento() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/elementos", this.datoElemento);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarElemento() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/elementos", this.datoElemento);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoElemento = {};
      this.titulo       = "Crear Elemento";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idElemento) {
      this.modalWindow = true;
      this.titulo      = "Editar Elemento";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwelementos/" + idElemento);
        this.datoElemento = resp.data;
      } catch (e) {
        console.error("Error al cargar elemento:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idElemento) {
      if (idElemento != null) this.$router.push("/elemento_tarifapres/" + idElemento);
    },
  },
};
</script>